var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('section',{staticClass:"section-heading"},[_c('div',{staticClass:"holder container"},[_c('div',{staticClass:"heading-wrap"},[(_vm.title)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.introText)?_c('p',[_vm._v(_vm._s(_vm.introText))]):_vm._e()])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }